import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import SummariesActions from 'app/actions/SummariesActions';
import UgcEditorActions from 'app/actions/UgcEditorActions';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectSummariesTransactions } from 'app/selectors/ugc/SummariesSelector';
import { selectSummaryEntities } from 'app/selectors/EntitiesSelector';
import { selectOpenUgcEditors } from 'app/selectors/ui/UgcEditorSelector';
import { SummaryEditor } from '.';

export class SummaryEditorContainer extends React.PureComponent {
  render() {
    return <SummaryEditor {...this.props} />;
  }
}

SummaryEditorContainer.propTypes = {
  // ownProps
  catalogBib: catalogBibShape,
  summaryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleSuccess: PropTypes.func,
  handleCancel: PropTypes.func,

  // Props from Redux store
  open: PropTypes.bool,
  currentUser: userIdentityShape,
  initialContent: PropTypes.string,
  summariesTransactions: ImmutablePropTypes.map.isRequired,
  summariesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ugcEditorActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = (state, ownProps) => {
  const { summaryId } = ownProps;
  return {
    currentUser: selectCurrentUser(state),
    summariesTransactions: selectSummariesTransactions(state),
    initialContent: summaryId ? selectSummaryEntities(state).getIn([summaryId.toString(), 'summary']) : '',
    open: !!summaryId || selectOpenUgcEditors(state).has('summary')
  };
};

const mapDispatchToProps = dispatch => ({
  summariesActions: bindActionCreators(SummariesActions, dispatch),
  ugcEditorActions: bindActionCreators(UgcEditorActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SummaryEditorContainer);
